export default "__VITE_ASSET__Cr7tqYK8__"